import { storyblokImageSizes } from '../consts';

export const getImageWidth = (url: string) => {
  // matches /1280x960/
  const match = url.match(/\/(\d+)x\d+\//);
  if (match) return parseInt(match[1]);
};

export const getImageHeight = (url: string) => {
  // matches /1280x960/
  const match = url.match(/\/\d+x(\d+)\//);
  if (match) return parseInt(match[1]);
};

export const getPictureSourceSizes = (url: string, maxWidth: number) => {
  const imageWidth = getImageWidth(url) || Infinity;
  const sizes: number[] = [];
  for (const i in storyblokImageSizes) {
    const size = storyblokImageSizes[i];
    if (size === 0) continue;
    // Never offer rungs above the source width — the CDN upscales, which only
    // adds bytes (a 1280px source at /m/2400x0 is ~2× the file size).
    if (size > imageWidth) continue;
    // Cap at 2× the display width (retina). Browsers round *up* to the next
    // rung, so offering anything above the cap guarantees over-fetch — the
    // largest rung ≤ 2× is visually equivalent (≥1.8× effective DPR).
    if (maxWidth && size > maxWidth * 2) continue;
    sizes.push(size);
  }

  // Tiny sources (below the smallest rung): keep one rung so srcset/sizes
  // stay functional; matches the previous fallback behavior.
  if (!sizes.length) sizes.push(storyblokImageSizes[storyblokImageSizes.length - 2]);

  return sizes;
};

export const minimalTextSchema = {
  nodes: {},
  marks: {},
};
